module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(_vm.$route.params.template == 0) ? _c('h6', [_vm._v("\n         " + _vm._s(_vm.$route.name) + " -\n         " + _vm._s(_vm.$sessionsStorage.get("booking_resp_frt_enq_id") > 0 ? _vm.form.enquiry_no : "") + "\n         - Booking NO -" + _vm._s(_vm.$sessionsStorage.get("booking_resp_frt_enq_id") > 0 ?
    _vm.form.enquiry_booking_no :
    "") + "\n       ")]) : (_vm.$route.params.template == 1) ? _c('h6', [_vm._v("Add Booking Response Template")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('b-col', {
    staticClass: "mx-auto text-right",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "xxl",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("\n               Back\n             ")]), _vm._v(" "), (_vm.$route.params.template == 0) ? _c('b-button', {
    attrs: {
      "size": "xxl",
      "disabled": _vm.isSubmited,
      "variant": "outline-success"
    },
    on: {
      "click": function($event) {
        _vm.saveBookingResp(0)
      }
    }
  }, [(_vm.isSubmited) ? _c('md-spinner', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "md-indeterminate": ""
    }
  }) : _vm._e(), _vm._v("\n               Save\n             ")], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.template == 1) ? _c('b-button', {
    attrs: {
      "size": "xxl",
      "disabled": _vm.isSubmited,
      "variant": "outline-success"
    },
    on: {
      "click": function($event) {
        _vm.saveBookingResp(1)
      }
    }
  }, [(_vm.isSubmited) ? _c('md-spinner', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "md-indeterminate": ""
    }
  }) : _vm._e(), _vm._v("\n               Save Template\n             ")], 1) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "table-header"
  }, [_c('div', {
    staticClass: "table-responsive tableMain col-md-12"
  }, [_c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_c('tbody', {
    staticStyle: {
      "background": "white"
    }
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "background-color": "yellow"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Field")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "yellow"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Value")])]), _vm._v(" "), (_vm.$route.params.template == 1) ? _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Template Name."), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [(_vm.$route.params.template == 1) ? _c('b-form-input', {
    style: ({
      borderColor:
        !_vm.form.template_name && _vm.errorList.template_name ? 'red' : '',
    }),
    attrs: {
      "aria-placeholder": "Please Enter Template Name"
    },
    model: {
      value: (_vm.form.template_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "template_name", $$v)
      },
      expression: "form.template_name"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.form.template_name) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.template_name) + "\n                       ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.$route.params.template == 1) ? _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Template Valid Till"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [(_vm.$route.params.template == 1) ? _c('b-form-input', {
    style: ({
      width: '180px',
      borderColor:
        !_vm.form.template_valid_till && _vm.errorList.template_valid_till ?
        'red' :
        '',
    }),
    attrs: {
      "type": "date",
      "aria-placeholder": "Please Enter Template Valid Till"
    },
    model: {
      value: (_vm.form.template_valid_till),
      callback: function($$v) {
        _vm.$set(_vm.form, "template_valid_till", $$v)
      },
      expression: "form.template_valid_till"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.form.template_valid_till) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.template_valid_till) + "\n                       ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Booking Type")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.BookingTypeList,
      "option-value": "bkgval",
      "option-text": "bkgtxt",
      "placeholder": "Select Booking Type"
    },
    on: {
      "input": function($event) {
        _vm.getClearContractNoErr()
      }
    },
    model: {
      value: (_vm.form.bookingType),
      callback: function($$v) {
        _vm.$set(_vm.form, "bookingType", $$v)
      },
      expression: "form.bookingType"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Billing Type")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.BillingTypeList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Billing Type"
    },
    model: {
      value: (_vm.form.billing_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "billing_type", $$v)
      },
      expression: "form.billing_type"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("INCO TERM SHIPMENT TERM")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.inco_term && _vm.errorList.inco_term ? 'red' : '',
    }),
    attrs: {
      "list": _vm.deliveryTermsList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Incoterm",
      "required": ""
    },
    model: {
      value: (_vm.form.inco_term),
      callback: function($$v) {
        _vm.$set(_vm.form, "inco_term", $$v)
      },
      expression: "form.inco_term"
    }
  }), _vm._v(" "), (!_vm.form.inco_term) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.inco_term) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.$route.params.type == 0) ? _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Line Booking No."), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [(_vm.$route.params.type == 0) ? _c('b-form-input', {
    style: ({
      borderColor:
        !_vm.form.booking_no && _vm.errorList.booking_no ? 'red' : '',
    }),
    attrs: {
      "aria-placeholder": "Please Enter Line Booking No"
    },
    model: {
      value: (_vm.form.booking_no),
      callback: function($$v) {
        _vm.$set(_vm.form, "booking_no", $$v)
      },
      expression: "form.booking_no"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.form.booking_no) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.booking_no) + "\n                       ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.$route.params.type == 0 || _vm.$route.params.type == 1) ? _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Booking For"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.booking_for && _vm.errorList.booking_for ? 'red' : '',
    }),
    attrs: {
      "list": _vm.BookingForList,
      "option-value": "bkgval",
      "option-text": "bkgtxt",
      "placeholder": "Select Booking For"
    },
    on: {
      "input": function($event) {
        _vm.clearError()
      }
    },
    model: {
      value: (_vm.form.booking_for),
      callback: function($$v) {
        _vm.$set(_vm.form, "booking_for", $$v)
      },
      expression: "form.booking_for"
    }
  }), _vm._v(" "), (!_vm.form.booking_for) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.booking_for) + "\n                       ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.form.booking_for == 'Agent') ? _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                       AGENT"), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.form.booking_for == "Agent" ? "*" : ""))])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        (!_vm.form.fk_agent_id && _vm.errorList.fk_agent_id && _vm.form.booking_for == 'Agent') ? 'red' : '',
    }),
    attrs: {
      "list": _vm.$store.getters['common/getAllAgentColoaderList'],
      "option-value": "agntColoaderId",
      "option-text": "agentName",
      "placeholder": "Select AGENT"
    },
    on: {
      "input": function($event) {
        _vm.getAgentHandlingExpense(_vm.form.fk_agent_id)
      }
    },
    model: {
      value: (_vm.form.fk_agent_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_agent_id", $$v)
      },
      expression: "form.fk_agent_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_agent_id && _vm.form.booking_for == 'Agent') ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.fk_agent_id) + "\n                       ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.form.booking_for == 'Client') ? _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SHIPPER"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('div', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientType),
      expression: "clientType"
    }],
    attrs: {
      "type": "radio",
      "value": "existing"
    },
    domProps: {
      "checked": _vm._q(_vm.clientType, "existing")
    },
    on: {
      "input": function($event) {
        _vm.chnageShipper(_vm.clientType)
      },
      "change": function($event) {
        _vm.clientType = "existing"
      }
    }
  }), _vm._v(" Existing\n                           SHIPPER\n                         ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientType),
      expression: "clientType"
    }],
    attrs: {
      "type": "radio",
      "value": "new"
    },
    domProps: {
      "checked": _vm._q(_vm.clientType, "new")
    },
    on: {
      "input": function($event) {
        _vm.chnageShipper(_vm.clientType)
      },
      "change": function($event) {
        _vm.clientType = "new"
      }
    }
  }), _vm._v("\n                           New SHIPPER\n                         ")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('model-list-select', {
    style: ({
      borderColor: !_vm.form.fk_client_id && _vm.errorList.fk_client_id ? 'red' : '',
    }),
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientfilter",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select SHIPPER",
      "required": ""
    },
    model: {
      value: (_vm.form.fk_client_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_client_id", $$v)
      },
      expression: "form.fk_client_id"
    }
  }), _vm._v(" "), (_vm.clientType === 'new') ? _c('div', {
    staticClass: "ml-2"
  }, [_c('b-button', {
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.addShipperModal
    }
  }, [_vm._v("\n                             Add New SHIPPER\n                           ")])], 1) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                       EXPENSES HANDLING AGENT"), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.form.booking_for == "Agent" ? "" : ""))])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        (!_vm.form.fk_agent_id && _vm.errorList.fk_agent_id && _vm.form.booking_for == 'Agent') ? 'red' : '',
    }),
    attrs: {
      "isDisabled": _vm.form.booking_for == 'Agent' ? true : false,
      "list": _vm.$store.getters['common/getAllAgentColoaderList'],
      "option-value": "agntColoaderId",
      "option-text": "agentName",
      "placeholder": "Select AGENT"
    },
    on: {
      "input": function($event) {
        _vm.getAgentHandlingExpense(_vm.form.fk_agent_id)
      }
    },
    model: {
      value: (_vm.form.fk_agent_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_agent_id", $$v)
      },
      expression: "form.fk_agent_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_agent_id && _vm.form.booking_for == 'Agent') ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.fk_agent_id) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                       AGENT HANDLING EXPENSES to PRIDEL"), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.form.booking_for == "Agent" ? "" : ""))])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        (!_vm.form.agent_handling_expense && _vm.errorList.agent_handling_expense && _vm.form.fk_agent_id) ? 'red' : '',
    }),
    attrs: {
      "isDisabled": _vm.form.booking_for == 'Agent' ? true : false,
      "list": _vm.agentHandlingExpenseList,
      "option-value": "bkgval",
      "option-text": "bkgtxt",
      "placeholder": "Select AGENT"
    },
    model: {
      value: (_vm.form.agent_handling_expense),
      callback: function($$v) {
        _vm.$set(_vm.form, "agent_handling_expense", $$v)
      },
      expression: "form.agent_handling_expense"
    }
  }), _vm._v(" "), (!_vm.form.agent_handling_expense && _vm.form.fk_agent_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.agent_handling_expense) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Enquiry No.")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.form.enquiry_no),
      callback: function($$v) {
        _vm.$set(_vm.form, "enquiry_no", $$v)
      },
      expression: "form.enquiry_no"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Shipment Type: "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.shipment_type && _vm.errorList.shipment_type ? 'red' : '',
    }),
    attrs: {
      "list": _vm.shipment_typeList,
      "id": "shipment_type",
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Please Select Shipment Type"
    },
    model: {
      value: (_vm.form.shipment_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "shipment_type", $$v)
      },
      expression: "form.shipment_type"
    }
  }), _vm._v(" "), (!_vm.form.shipment_type) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.shipment_type) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Transport Type"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.transport_type && _vm.errorList.transport_type ?
        'red' :
        '',
    }),
    attrs: {
      "list": _vm.moduelTypeList,
      "id": "transport_type",
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Please Select Transport Type"
    },
    model: {
      value: (_vm.form.transport_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "transport_type", $$v)
      },
      expression: "form.transport_type"
    }
  }), _vm._v(" "), (!_vm.form.transport_type) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.transport_type) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Branch"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    staticClass: "ml-1",
    style: ({
      borderColor:
        !_vm.form.fk_branch_id && _vm.errorList.fk_branch_id ? 'red' : '',
    }),
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "fk_branch_id",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Branch"
    },
    model: {
      value: (_vm.form.fk_branch_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_branch_id", $$v)
      },
      expression: "form.fk_branch_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_branch_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.fk_branch_id) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                       FREIGHT TERMS ( MBL)"), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.freight_terms_mbl && _vm.errorList.freight_terms_mbl ? 'red' : '',
    }),
    attrs: {
      "list": _vm.oceanFreightTermsName,
      "option-value": "TermsVal",
      "option-text": "TermsText",
      "placeholder": "Select FREIGHT TERMS ( MBL)"
    },
    model: {
      value: (_vm.form.freight_terms_mbl),
      callback: function($$v) {
        _vm.$set(_vm.form, "freight_terms_mbl", $$v)
      },
      expression: "form.freight_terms_mbl"
    }
  }), _vm._v(" "), (!_vm.form.freight_terms_mbl) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.freight_terms_mbl) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                       FREIGHT TERMS ( HBL)"), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.freight_terms_hbl && _vm.errorList.freight_terms_hbl ? 'red' : '',
    }),
    attrs: {
      "list": _vm.oceanFreightTermsName,
      "option-value": "TermsVal",
      "option-text": "TermsText",
      "placeholder": "Select FREIGHT TERMS ( HBL)"
    },
    model: {
      value: (_vm.form.freight_terms_hbl),
      callback: function($$v) {
        _vm.$set(_vm.form, "freight_terms_hbl", $$v)
      },
      expression: "form.freight_terms_hbl"
    }
  }), _vm._v(" "), (!_vm.form.freight_terms_hbl) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.freight_terms_hbl) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                       DESTINATION CHARGES"), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.destination_charges && _vm.errorList.destination_charges ? 'red' : '',
    }),
    attrs: {
      "list": _vm.oceanFreightTermsName,
      "option-value": "TermsVal",
      "option-text": "TermsText",
      "placeholder": "Select DESTINATION CHARGES"
    },
    model: {
      value: (_vm.form.destination_charges),
      callback: function($$v) {
        _vm.$set(_vm.form, "destination_charges", $$v)
      },
      expression: "form.destination_charges"
    }
  }), _vm._v(" "), (!_vm.form.destination_charges) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.destination_charges) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("DESTINATION CHARGES Det.")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('b-form-input', {
    model: {
      value: (_vm.form.destination_charges_det),
      callback: function($$v) {
        _vm.$set(_vm.form, "destination_charges_det", $$v)
      },
      expression: "form.destination_charges_det"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                       First Mile Booking"), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.first_mile_booking && _vm.errorList.first_mile_booking ? 'red' : '',
    }),
    attrs: {
      "list": _vm.firstMileBookingList,
      "option-value": "bkgval",
      "option-text": "bkgtxt",
      "placeholder": "Select First Mile Booking"
    },
    model: {
      value: (_vm.form.first_mile_booking),
      callback: function($$v) {
        _vm.$set(_vm.form, "first_mile_booking", $$v)
      },
      expression: "form.first_mile_booking"
    }
  }), _vm._v(" "), (!_vm.form.first_mile_booking) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.first_mile_booking) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                       Destination Delivery Mode"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.delivery_mode && _vm.errorList.delivery_mode ? 'red' : '',
    }),
    attrs: {
      "list": _vm.deliveryModeName,
      "option-value": "deliveryModeVal",
      "option-text": "deliveryModeText",
      "placeholder": "Select Destination Delivery Mode"
    },
    model: {
      value: (_vm.form.delivery_mode),
      callback: function($$v) {
        _vm.$set(_vm.form, "delivery_mode", $$v)
      },
      expression: "form.delivery_mode"
    }
  }), _vm._v(" "), (!_vm.form.delivery_mode) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.delivery_mode) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("EMPTY PICK UP"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.fk_epk_id && _vm.errorList.fk_epk_id ? 'red' : '',
    }),
    attrs: {
      "list": _vm.form.transport_type == 'CRC' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
        ] :
        _vm.form.transport_type == 'EXPORT' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'
        ] :
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPORDDList'
        ],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POR"
    },
    model: {
      value: (_vm.form.fk_epk_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_epk_id", $$v)
      },
      expression: "form.fk_epk_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_epk_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.fk_epk_id) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("HANDOVER"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.fk_por_id && _vm.errorList.fk_por_id ? 'red' : '',
    }),
    attrs: {
      "list": _vm.form.transport_type == 'CRC' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
        ] :
        _vm.form.transport_type == 'EXPORT' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'
        ] :
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPORDDList'
        ],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POR"
    },
    model: {
      value: (_vm.form.fk_por_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_por_id", $$v)
      },
      expression: "form.fk_por_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_por_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.fk_por_id) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("POL"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.fk_pol_id && _vm.errorList.fk_pol_id ? 'red' : '',
    }),
    attrs: {
      "list": _vm.form.transport_type == 'CRC' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
        ] :
        _vm.form.transport_type == 'EXPORT' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList'
        ] :
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPOLDDList'
        ],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POL"
    },
    model: {
      value: (_vm.form.fk_pol_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_pol_id", $$v)
      },
      expression: "form.fk_pol_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_pol_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.fk_pol_id) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("POD"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.fk_pod_id && _vm.errorList.fk_pod_id ? 'red' : '',
    }),
    attrs: {
      "list": _vm.form.transport_type == 'CRC' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
        ] :
        _vm.form.transport_type == 'EXPORT' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList'
        ] :
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPODDDList'
        ],
      "option-value": "pickupId",
      "option-text": "location",
      "placeholder": "Select POD"
    },
    model: {
      value: (_vm.form.fk_pod_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_pod_id", $$v)
      },
      expression: "form.fk_pod_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_pod_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.fk_pod_id) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("FINAL DESTINATION"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.fk_fpod_id && _vm.errorList.fk_fpod_id ? 'red' : '',
    }),
    attrs: {
      "list": _vm.form.transport_type == 'CRC' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
        ] :
        _vm.form.transport_type == 'EXPORT' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList'
        ] :
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPFPODDDList'
        ],
      "option-value": "pickupId",
      "option-text": "location",
      "placeholder": "Select FPOD"
    },
    model: {
      value: (_vm.form.fk_fpod_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_fpod_id", $$v)
      },
      expression: "form.fk_fpod_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_fpod_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.fk_fpod_id) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("RA NUMBER "), (_vm.form.bookingType == 'ON CONTRACT') ? _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]) : _vm._e(), _vm._v("\n                          \n                       "), _c('b-button', {
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.openContractModal()
      }
    }
  }, [_vm._v("Add")])], 1), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    staticClass: "ml-1",
    style: ({
      borderColor:
        !_vm.form.fk_contract_id && _vm.errorList.fk_contract_id ?
        'red' :
        '',
    }),
    attrs: {
      "list": _vm.$store.getters['common/getAllContractList'],
      "id": "fk_contract_id",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select RA NUMBER"
    },
    on: {
      "input": function($event) {
        _vm.getContractNo(_vm.form.fk_contract_id)
      }
    },
    model: {
      value: (_vm.form.fk_contract_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_contract_id", $$v)
      },
      expression: "form.fk_contract_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_contract_id && _vm.errorList.fk_contract_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.fk_contract_id) + "\n                       ")]) : _vm._e(), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor:
        !_vm.form.ra_number && _vm.errorList.ra_number ? 'red' : '',
    }),
    attrs: {
      "disabled": true,
      "type": "text"
    },
    model: {
      value: (_vm.form.ra_number),
      callback: function($$v) {
        _vm.$set(_vm.form, "ra_number", $$v)
      },
      expression: "form.ra_number"
    }
  }), _vm._v(" "), (!_vm.form.ra_number) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.ra_number) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Vessel Name "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-button', {
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.openVesselModal()
      }
    }
  }, [_vm._v("Add")])], 1), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    staticClass: "ml-1",
    style: ({
      borderColor:
        !_vm.form.vessel_name && _vm.errorList.fk_ccbm_id ?
        'red' :
        '',
    }),
    attrs: {
      "list": _vm.$store.getters['common/getAllContractBasedVesselList'],
      "id": "vessel_name",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Vessel Name"
    },
    on: {
      "input": function($event) {
        _vm.getAllContractBasedVesselList(_vm.form.fk_ccbm_id)
      }
    },
    model: {
      value: (_vm.form.fk_ccbm_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_ccbm_id", $$v)
      },
      expression: "form.fk_ccbm_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_ccbm_id && _vm.errorList.fk_ccbm_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.fk_ccbm_id) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col",
      "colspan": "2"
    }
  }, [_c('table', {
    staticClass: "table table-sm table-bordered mt-2"
  }, [_c('tbody', {
    staticStyle: {
      "background": "white"
    }
  }, [(_vm.CONTAINERCOUNTArr.length > 0) ? _c('tr', [_c('th', {
    staticStyle: {
      "width": "5px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                               CONTAINER TYPE"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                               CONTAINER COUNT"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                               CURRENCY"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                               Buying Rate"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                               Selling Rate"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Remark")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                               Actions\n                               "), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.addContainerCount()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle ml-1"
  })])], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.CONTAINERCOUNTArr), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_c('model-list-select', {
      style: ({
        borderColor:
          !item.fk_cont_type_id && _vm.errorList.fk_cont_type_id ?
          'red' :
          '',
      }),
      attrs: {
        "list": _vm.$store.getters['common/getAllContainerTypeList'],
        "option-value": "containerTypeId",
        "option-text": "containerType",
        "placeholder": "Select Container Type"
      },
      model: {
        value: (item.fk_cont_type_id),
        callback: function($$v) {
          _vm.$set(item, "fk_cont_type_id", $$v)
        },
        expression: "item.fk_cont_type_id"
      }
    }), _vm._v(" "), (item.fk_cont_type_id_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.fk_cont_type_id_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "placeholder": "Enter Container Count"
      },
      model: {
        value: (item.brcm_tot_continer),
        callback: function($$v) {
          _vm.$set(item, "brcm_tot_continer", $$v)
        },
        expression: "item.brcm_tot_continer"
      }
    }), _vm._v(" "), (item.brcm_tot_continer_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.brcm_tot_continer_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "list": _vm.$store.getters['common/getAllCurrencyList'],
        "option-value": "currency_id",
        "option-text": "currencyCode",
        "placeholder": "Select Currency"
      },
      model: {
        value: (item.fk_currency_id),
        callback: function($$v) {
          _vm.$set(item, "fk_currency_id", $$v)
        },
        expression: "item.fk_currency_id"
      }
    }), _vm._v(" "), (item.fk_currency_id_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.fk_currency_id_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "placeholder": "Enter Buying Rate"
      },
      model: {
        value: (item.brcm_rate),
        callback: function($$v) {
          _vm.$set(item, "brcm_rate", $$v)
        },
        expression: "item.brcm_rate"
      }
    }), _vm._v(" "), (item.brcm_rate_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.brcm_rate_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "placeholder": "Enter Selling Rate"
      },
      model: {
        value: (item.brcm_sell_rate),
        callback: function($$v) {
          _vm.$set(item, "brcm_sell_rate", $$v)
        },
        expression: "item.brcm_sell_rate"
      }
    }), _vm._v(" "), (item.brcm_sell_rate_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.brcm_sell_rate_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-textarea', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "row": "2",
        "placeholder": "Enter Remark"
      },
      model: {
        value: (item.brcm_continer_remark),
        callback: function($$v) {
          _vm.$set(item, "brcm_continer_remark", $$v)
        },
        expression: "item.brcm_continer_remark"
      }
    }), _vm._v(" "), (item.brcm_continer_remark_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.brcm_continer_remark_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(index > 0) ? _c('b-button', {
      attrs: {
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removeContainerCount(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()], 1)])
  })], 2)])])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Commodity Type"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.commodity_type && _vm.errorList.commodity_type ?
        'red' :
        '',
    }),
    attrs: {
      "list": _vm.commodityTypeList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Commodity Type"
    },
    model: {
      value: (_vm.form.commodity_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "commodity_type", $$v)
      },
      expression: "form.commodity_type"
    }
  }), _vm._v(" "), (!_vm.form.commodity_type) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.commodity_type) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.form.commodity_type == 'Hazardous') ? _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("IMDG Class")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('b-form-input', {
    style: ({
      borderColor:
        !_vm.form.imdg_class && _vm.errorList.imdg_class ? 'red' : '',
    }),
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "imdg_class",
      "name": "imdg_class"
    },
    model: {
      value: (_vm.form.imdg_class),
      callback: function($$v) {
        _vm.$set(_vm.form, "imdg_class", $$v)
      },
      expression: "form.imdg_class"
    }
  }), _vm._v(" "), (!_vm.form.imdg_class) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.imdg_class) + "\n                       ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.form.commodity_type == 'Hazardous') ? _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("UN Number")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('b-form-input', {
    style: ({
      borderColor:
        !_vm.form.un_number && _vm.errorList.un_number ? 'red' : '',
    }),
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "un_number",
      "name": "un_number"
    },
    model: {
      value: (_vm.form.un_number),
      callback: function($$v) {
        _vm.$set(_vm.form, "un_number", $$v)
      },
      expression: "form.un_number"
    }
  }), _vm._v(" "), (!_vm.form.un_number) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.un_number) + "\n                       ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.form.commodity_type == 'Hazardous') ? _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Packing Code")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('b-form-input', {
    style: ({
      borderColor:
        !_vm.form.packing_code && _vm.errorList.packing_code ? 'red' : '',
    }),
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "packing_code",
      "name": "packing_code"
    },
    model: {
      value: (_vm.form.packing_code),
      callback: function($$v) {
        _vm.$set(_vm.form, "packing_code", $$v)
      },
      expression: "form.packing_code"
    }
  }), _vm._v(" "), (!_vm.form.packing_code) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.packing_code) + "\n                       ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.form.commodity_type == 'Reefer') ? _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Temperature Req(Degree Celsius)")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('b-form-input', {
    style: ({
      borderColor:
        (!_vm.form.temperature_required &&
          _vm.errorList.temperature_required) ||
        _vm.form.temperature_required > 100 ?
        'red' :
        '',
    }),
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "temperature_required",
      "name": "temperature_required",
      "min": 0,
      "max": 100,
      "type": "number"
    },
    on: {
      "keyup": function($event) {
        _vm.validateDegree('temperature_required')
      }
    },
    model: {
      value: (_vm.form.temperature_required),
      callback: function($$v) {
        _vm.$set(_vm.form, "temperature_required", $$v)
      },
      expression: "form.temperature_required"
    }
  }), _vm._v(" "), (_vm.form.temperature_required > 100) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("Temperature Req(Degree Celsius) Must\n                         Be Less Than Equal To\n                         100")]) : _vm._e(), _vm._v(" "), (!_vm.form.temperature_required) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.temperature_required) + "\n                       ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.form.commodity_type == 'Others') ? _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Specific Detail if any..!")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('b-form-input', {
    style: ({
      borderColor:
        !_vm.form.other_comodity && _vm.errorList.other_comodity ?
        'red' :
        '',
    }),
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "other_comodity",
      "name": "other_comodity"
    },
    model: {
      value: (_vm.form.other_comodity),
      callback: function($$v) {
        _vm.$set(_vm.form, "other_comodity", $$v)
      },
      expression: "form.other_comodity"
    }
  }), _vm._v(" "), (!_vm.form.other_comodity) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.other_comodity) + "\n                       ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("COMMODITY & HS CODE"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.fk_commodity_id && _vm.errorList.fk_commodity_id ?
        'red' :
        '',
    }),
    attrs: {
      "list": _vm.commodityList,
      "option-value": "commodityId",
      "option-text": "itemHSNCode",
      "placeholder": "Select Commodity"
    },
    on: {
      "searchchange": function($event) {
        _vm.getCommodityList($event, 'getCommodityData')
      }
    },
    model: {
      value: (_vm.form.fk_commodity_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_commodity_id", $$v)
      },
      expression: "form.fk_commodity_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_commodity_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.fk_commodity_id) + " ")]) : _vm._e(), _c('b-button', {
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.openCommodityModal()
      }
    }
  }, [_vm._v("Add")])], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("HUMIDITY (for reefer)")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('b-form-input', {
    style: ({
      borderColor:
        (!_vm.form.humidity && _vm.errorList.humidity) ||
        _vm.form.humidity > 100 ?
        'red' :
        '',
    }),
    attrs: {
      "required": "",
      "min": 0,
      "max": 100,
      "type": "number"
    },
    on: {
      "keyup": function($event) {
        _vm.validateDegree('humidity')
      }
    },
    model: {
      value: (_vm.form.humidity),
      callback: function($$v) {
        _vm.$set(_vm.form, "humidity", $$v)
      },
      expression: "form.humidity"
    }
  }), _vm._v(" "), (_vm.form.humidity > 100) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("HUMIDITY Must Be Less Than Equal To 100")]) : _vm._e(), _vm._v(" "), (!_vm.form.humidity) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.humidity) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("CARGO WEIGHT")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('b-form-input', {
    style: ({
      borderColor:
        !_vm.form.cargo_weight && _vm.errorList.cargo_weight ? 'red' : '',
    }),
    model: {
      value: (_vm.form.cargo_weight),
      callback: function($$v) {
        _vm.$set(_vm.form, "cargo_weight", $$v)
      },
      expression: "form.cargo_weight"
    }
  }), _vm._v(" "), (!_vm.form.cargo_weight) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.cargo_weight) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SHIPPING LINE"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.fk_shipping_id && _vm.errorList.fk_shipping_id ?
        'red' :
        '',
    }),
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.form.fk_shipping_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_shipping_id", $$v)
      },
      expression: "form.fk_shipping_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_shipping_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.fk_shipping_id) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SPOT NON SPOT")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.spot_non_spot && _vm.errorList.spot_non_spot ? 'red' : '',
    }),
    attrs: {
      "list": _vm.spotList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Spot Non-Spot"
    },
    model: {
      value: (_vm.form.spot_non_spot),
      callback: function($$v) {
        _vm.$set(_vm.form, "spot_non_spot", $$v)
      },
      expression: "form.spot_non_spot"
    }
  }), _vm._v(" "), (!_vm.form.spot_non_spot) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.spot_non_spot) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Currency")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.fk_currency_id && _vm.errorList.fk_currency_id ?
        'red' :
        '',
    }),
    attrs: {
      "list": _vm.$store.getters['common/getAllCurrencyList'],
      "option-value": "currency_id",
      "option-text": "currencyCode",
      "placeholder": "Select Currency"
    },
    on: {
      "input": function($event) {
        _vm.getCurrencyName(_vm.form.fk_currency_id)
      }
    },
    model: {
      value: (_vm.form.fk_currency_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_currency_id", $$v)
      },
      expression: "form.fk_currency_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_currency_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.fk_currency_id) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("FREE DAYS At POD"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('b-form-input', {
    style: ({
      borderColor:
        !_vm.form.free_days && _vm.errorList.free_days ? 'red' : '',
    }),
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.form.free_days),
      callback: function($$v) {
        _vm.$set(_vm.form, "free_days", $$v)
      },
      expression: "form.free_days"
    }
  }), _vm._v(" "), (!_vm.form.free_days) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.free_days) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("PDA"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor: !_vm.form.pda && _vm.errorList.pda ? 'red' : '',
    }),
    attrs: {
      "list": _vm.pdaList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select PDA"
    },
    model: {
      value: (_vm.form.pda),
      callback: function($$v) {
        _vm.$set(_vm.form, "pda", $$v)
      },
      expression: "form.pda"
    }
  }), _vm._v(" "), (!_vm.form.pda) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.pda) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SI CUT OFF"), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('b-form-input', {
    style: ({
      width: '180px',
      borderColor: !_vm.form.si_cut_of_date && _vm.errorList.si_cut_of_date ? 'red' : '',
    }),
    attrs: {
      "disabled": _vm.form.fk_ccbm_id ? true : false,
      "type": "date"
    },
    model: {
      value: (_vm.form.si_cut_of_date),
      callback: function($$v) {
        _vm.$set(_vm.form, "si_cut_of_date", $$v)
      },
      expression: "form.si_cut_of_date"
    }
  }), _vm._v(" "), (!_vm.form.si_cut_of_date) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.si_cut_of_date) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("ETD/SOB"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('b-form-input', {
    style: ({
      width: '180px',
      borderColor: !_vm.form.etd && _vm.errorList.etd ? 'red' : '',
    }),
    attrs: {
      "disabled": _vm.form.fk_ccbm_id ? true : false,
      "type": "date"
    },
    model: {
      value: (_vm.form.etd),
      callback: function($$v) {
        _vm.$set(_vm.form, "etd", $$v)
      },
      expression: "form.etd"
    }
  }), _vm._v(" "), (!_vm.form.etd) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.etd) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Valid Till"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('b-form-input', {
    style: ({
      width: '180px',
      borderColor:
        !_vm.form.valid_till && _vm.errorList.valid_till ? 'red' : '',
    }),
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.form.valid_till),
      callback: function($$v) {
        _vm.$set(_vm.form, "valid_till", $$v)
      },
      expression: "form.valid_till"
    }
  }), _vm._v(" "), (!_vm.form.valid_till) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.valid_till) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                       Quotation Validity Till"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.quotation_till && _vm.errorList.quotation_till ?
        'red' :
        '',
    }),
    attrs: {
      "list": _vm.qTillList,
      "option-value": "qV",
      "option-text": "qT",
      "placeholder": "Select Quotation Validity Till"
    },
    model: {
      value: (_vm.form.quotation_till),
      callback: function($$v) {
        _vm.$set(_vm.form, "quotation_till", $$v)
      },
      expression: "form.quotation_till"
    }
  }), _vm._v(" "), (!_vm.form.quotation_till) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.quotation_till) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("BL INSTRUCTION")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.bl_instruction && _vm.errorList.bl_instruction ?
        'red' :
        '',
    }),
    attrs: {
      "list": _vm.blINSTRUCTIONList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select BL INSTRUCTION"
    },
    model: {
      value: (_vm.form.bl_instruction),
      callback: function($$v) {
        _vm.$set(_vm.form, "bl_instruction", $$v)
      },
      expression: "form.bl_instruction"
    }
  }), _vm._v(" "), (!_vm.form.bl_instruction) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.bl_instruction) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                       CS Team/Sales Person"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "fk_sales_person_id",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Sales Person"
    },
    model: {
      value: (_vm.form.fk_sales_person_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_sales_person_id", $$v)
      },
      expression: "form.fk_sales_person_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_sales_person_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                         " + _vm._s(_vm.errorList.fk_sales_person_id) + "\n                       ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("REMARKS (if any)")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('b-form-textarea', {
    model: {
      value: (_vm.form.remarks),
      callback: function($$v) {
        _vm.$set(_vm.form, "remarks", $$v)
      },
      expression: "form.remarks"
    }
  })], 1)])])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mx-auto text-center",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "xxl",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("\n                 Back\n               ")]), _vm._v(" "), (_vm.$route.params.template == 0) ? _c('b-button', {
    attrs: {
      "size": "xxl",
      "disabled": _vm.isSubmited,
      "variant": "outline-success"
    },
    on: {
      "click": function($event) {
        _vm.saveBookingResp(0)
      }
    }
  }, [(_vm.isSubmited) ? _c('md-spinner', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "md-indeterminate": ""
    }
  }) : _vm._e(), _vm._v("\n                 Save\n               ")], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.template == 1) ? _c('b-button', {
    attrs: {
      "size": "xxl",
      "disabled": _vm.isSubmited,
      "variant": "outline-success"
    },
    on: {
      "click": function($event) {
        _vm.saveBookingResp(1)
      }
    }
  }, [(_vm.isSubmited) ? _c('md-spinner', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "md-indeterminate": ""
    }
  }) : _vm._e(), _vm._v("\n                 Save Template\n               ")], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "Commodity-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": "Add Commodity"
    }
  }, [_c('b-row', {
    staticClass: "justify-content-center"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Item Name "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor:
        !_vm.commodityModal.itemName && _vm.errorComodityList.itemName ? 'red' : '',
    }),
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "itemName",
      "name": "itemName"
    },
    model: {
      value: (_vm.commodityModal.itemName),
      callback: function($$v) {
        _vm.$set(_vm.commodityModal, "itemName", $$v)
      },
      expression: "commodityModal.itemName"
    }
  }), _vm._v(" "), (!_vm.commodityModal.itemName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorComodityList.itemName))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("HSN Code "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor:
        !_vm.commodityModal.hsnCode && _vm.errorComodityList.hsnCode ? 'red' : '',
    }),
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "hsnCode",
      "name": "hsnCode"
    },
    model: {
      value: (_vm.commodityModal.hsnCode),
      callback: function($$v) {
        _vm.$set(_vm.commodityModal, "hsnCode", $$v)
      },
      expression: "commodityModal.hsnCode"
    }
  }), _vm._v(" "), (!_vm.commodityModal.hsnCode) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorComodityList.hsnCode))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-3 text-center"
  }, [_c('b-button', {
    attrs: {
      "disabled": _vm.commodityDisabled,
      "variant": "outline-primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": _vm.addCommodity
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-danger",
      "size": "sm"
    },
    on: {
      "click": _vm.hideCommodityModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "vesselModalRef",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": 'Add Vessel/Voyage-' + _vm.form.ra_number
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_vm._v("Vessel Name "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor:
        !_vm.vesselModal.vessel_name && _vm.errorVesselList.vessel_name ?
        'red' :
        '',
    }),
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "vessel_name",
      "name": "vessel_name"
    },
    model: {
      value: (_vm.vesselModal.vessel_name),
      callback: function($$v) {
        _vm.$set(_vm.vesselModal, "vessel_name", $$v)
      },
      expression: "vesselModal.vessel_name"
    }
  }), _vm._v(" "), (!_vm.vesselModal.vessel_name) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorVesselList.vessel_name))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_vm._v("Voyage No "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor:
        !_vm.vesselModal.vessel_voyage_no && _vm.errorVesselList.vessel_voyage_no ?
        'red' :
        '',
    }),
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "vessel_voyage_no",
      "name": "vessel_voyage_no"
    },
    model: {
      value: (_vm.vesselModal.vessel_voyage_no),
      callback: function($$v) {
        _vm.$set(_vm.vesselModal, "vessel_voyage_no", $$v)
      },
      expression: "vesselModal.vessel_voyage_no"
    }
  }), _vm._v(" "), (!_vm.vesselModal.vessel_voyage_no) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorVesselList.vessel_voyage_no))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_vm._v("SOB "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor:
        !_vm.vesselModal.vessel_sail_date && _vm.errorVesselList.vessel_sail_date ? 'red' : '',
    }),
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.vesselModal.vessel_sail_date),
      callback: function($$v) {
        _vm.$set(_vm.vesselModal, "vessel_sail_date", $$v)
      },
      expression: "vesselModal.vessel_sail_date"
    }
  }), _vm._v(" "), (!_vm.vesselModal.vessel_sail_date) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorVesselList.vessel_sail_date))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-3 text-center"
  }, [_c('b-button', {
    attrs: {
      "disabled": _vm.contractDisabled,
      "variant": "outline-primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": _vm.addVesselVoyage
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-danger",
      "size": "sm"
    },
    on: {
      "click": _vm.hideVesselModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "Contract-modal",
    staticClass: "w-90",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": "Add Contract"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('label', [_vm._v("Contract No "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor:
        !_vm.contractModal.cb_contarct_no && _vm.errorContractList.cb_contarct_no ?
        'red' :
        '',
    }),
    attrs: {
      "disabled": _vm.contractModal.cb_id > 0 ? true : false,
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "cb_contarct_no",
      "name": "cb_contarct_no"
    },
    model: {
      value: (_vm.contractModal.cb_contarct_no),
      callback: function($$v) {
        _vm.$set(_vm.contractModal, "cb_contarct_no", $$v)
      },
      expression: "contractModal.cb_contarct_no"
    }
  }), _vm._v(" "), (!_vm.contractModal.cb_contarct_no) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorContractList.cb_contarct_no))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-3 text-center"
  }, [_c('b-button', {
    attrs: {
      "disabled": _vm.contractDisabled,
      "variant": "outline-primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": _vm.addContract
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-danger",
      "size": "sm"
    },
    on: {
      "click": _vm.hideContractModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('b-modal', {
    ref: "ShipperModal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "title": "Add New Shipper",
      "size": "lg",
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.closeShipperModal
    }
  }, [_c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "client-name"
    }
  }, [_vm._v("Client Name"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "client-name",
      "placeholder": "Enter Client Name"
    },
    model: {
      value: (_vm.newShipperForm.clientName),
      callback: function($$v) {
        _vm.$set(_vm.newShipperForm, "clientName", $$v)
      },
      expression: "newShipperForm.clientName"
    }
  }), _vm._v(" "), (_vm.validationNewShipperErrors.clientName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n               " + _vm._s(_vm.validationNewShipperErrors.clientName) + "\n             ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "client-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "client-email",
      "type": "email",
      "placeholder": "Enter Email"
    },
    on: {
      "keyup": function($event) {
        _vm.isValidEmail(_vm.newShipperForm.email)
      }
    },
    model: {
      value: (_vm.newShipperForm.email),
      callback: function($$v) {
        _vm.$set(_vm.newShipperForm, "email", $$v)
      },
      expression: "newShipperForm.email"
    }
  }), _vm._v(" "), (_vm.validationNewShipperErrors.email) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n               " + _vm._s(_vm.validationNewShipperErrors.email) + "\n             ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "client-pan"
    }
  }, [_vm._v("PAN(AAAAA1234A)"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "client-pan",
      "placeholder": "Enter PAN Number"
    },
    on: {
      "keyup": function($event) {
        _vm.isValidPAN(_vm.newShipperForm.pan)
      }
    },
    model: {
      value: (_vm.newShipperForm.pan),
      callback: function($$v) {
        _vm.$set(_vm.newShipperForm, "pan", $$v)
      },
      expression: "newShipperForm.pan"
    }
  }), _vm._v(" "), (_vm.validationNewShipperErrors.pan) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n               " + _vm._s(_vm.validationNewShipperErrors.pan) + "\n             ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "client-gst"
    }
  }, [_vm._v("GST(09AAAAA1234A1Z5)"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "client-gst",
      "placeholder": "Enter GST Number"
    },
    on: {
      "keyup": function($event) {
        _vm.isValidGST(_vm.newShipperForm.gst)
      }
    },
    model: {
      value: (_vm.newShipperForm.gst),
      callback: function($$v) {
        _vm.$set(_vm.newShipperForm, "gst", $$v)
      },
      expression: "newShipperForm.gst"
    }
  }), _vm._v(" "), (_vm.validationNewShipperErrors.gst) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n               " + _vm._s(_vm.validationNewShipperErrors.gst) + "\n             ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('label', {
    attrs: {
      "for": "client-address"
    }
  }, [_vm._v("Address")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "id": "client-address",
      "placeholder": "Enter Address",
      "rows": "2"
    },
    model: {
      value: (_vm.newShipperForm.address),
      callback: function($$v) {
        _vm.$set(_vm.newShipperForm, "address", $$v)
      },
      expression: "newShipperForm.address"
    }
  }), _vm._v(" "), (_vm.validationNewShipperErrors.address) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n               " + _vm._s(_vm.validationNewShipperErrors.address) + "\n             ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-end"
  }, [_c('b-button', {
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.saveShipper
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.closeShipperModal
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fa9b12c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Pricing/newBookingResp.vue
// module id = 2442
// module chunks = 0